exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".thankyou{text-align:center}.thankyou h2{letter-spacing:0}.contact-button.back-home a{float:none;margin:0 auto;width:200px;display:block;text-align:center;padding:10px 20px;background:#bb822c;border-color:#bb822c}.disclaimer{font-size:10px;opacity:.7;padding-bottom:100px!important}.disclaimer label{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/calculator/calculator.done/calculator.done.scss
// module id = 546
// module chunks = 0